import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    labelList: [],
    lastQuery: null,
};

const mutations = {
    [type.SET_LABEL_LIST](state, label) {
        state.labelList = label;
    },

    [type.ADD_LABEL](state, label) {
        state.labelList.push(label);
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const getters = {
    labels(state) {
        return state.labelList;
    },
};

const actions = {
    getLabelListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.labelList.length || state.lastQuery != params.query) {
            return dispatch('getLabelList', params);
        }

        return Promise.resolve(state.labelList);
    },

    getLabelList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-label');

        return axios
            .get(Laroute.route('franchise.vue.labels'), options)
            .then(res => {
                let data = res.data.data;

                commit(type.SET_LABEL_LIST, data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-label');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-label');
                throw err;
            });
    },

    getLabel({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.label.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-label');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-label');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-label');
                throw err;
            });
    },

    updateLabel({ commit, dispatch }, label) {
        let route = Laroute.route('franchise.label.update', {
            id: label.id,
        });
        startLoading(dispatch, 'save-label');

        return axios
            .patch(route, label)
            .then(res => {
                endLoading(dispatch, 'save-label');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-label');
                throw err;
            });
    },

    createLabel({ commit, dispatch }, label) {
        let route = Laroute.route('franchise.label.store');
        startLoading(dispatch, 'save-label');

        return axios
            .post(route, label)
            .then(res => {
                commit(type.ADD_LABEL, res.data);
                endLoading(dispatch, 'save-label');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-label');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
